var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_flex",staticStyle:{"max-width":"100px"}},[_c('input',{staticClass:"SlideToggle-input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }